/**
 * 「ゲームのファイルを入れるだけの小さな画面」の日本語（en.upload.ts と同じキーを全部持つ。漏れは typecheck で落ちる）。
 * 2026-10-04 creator/web-upload。言葉の決め事は en.upload.ts の冒頭と同じ:
 *   アップロード・ホスティング・デプロイ・環境・本番・版・トークンと書かない。日本のふつうのアプリの言い方で、短く。
 *   研究の言葉の例（見出し「「{name}」のファイルを入れる」・ボタン「入れる」・終わり「入れました。チャットに戻ってください。」）に合わせた
 */
import type { enUpload } from './en.upload';

type UploadMessages = { [K in keyof typeof enUpload]: string };

export const jaUpload: UploadMessages = {
  'upload.title': 'アプリのファイルを入れる',
  'upload.titleFor': '「{name}」のファイルを入れる',
  'upload.lead': 'チャットで作ったアプリの zip を、ここに落としてください（フォルダでもかまいません）。',
  'upload.where.production': '公開中のアプリ（{url}）に入れます。切り替える前に、チャットでもう一度確認します。',
  'upload.where.development': 'テスト用のアプリ（{url}）に入れます。入れたらすぐに試せます。',
  'upload.where.productionNoUrl': '公開中のアプリに入れます。切り替える前に、チャットでもう一度確認します。',
  'upload.where.developmentNoUrl': 'テスト用のアプリに入れます。入れたらすぐに試せます。',
  'upload.drop': 'ここに zip かフォルダを落とす',
  'upload.or': 'または',
  'upload.pickZip': 'zip を選ぶ',
  'upload.pickFolder': 'フォルダを選ぶ',
  'upload.reading': 'zip を開いています…',
  'upload.ready': '{count} ファイル・{size}',
  'upload.skipped': '{count} 個のファイルは入れません（パソコンが自動で作るファイルや、.env などのキーのファイル）。',
  'upload.button': '入れる',
  'upload.working': '入れています… {percent}%',
  'upload.doneTitle': '入れました',
  'upload.doneBody.development': 'チャットに戻ってください。このページは閉じてかまいません。',
  'upload.doneBody.production': 'チャットに戻って、公開するかを答えてください。このページは閉じてかまいません。',
  'upload.doneUrl': 'ここで試せます: {url}',
  'upload.again': '別のファイルを入れる',
  'upload.badLink': 'リンクが正しくありません。AI にもう一度ページを開いてもらってください。',
  'upload.issue.empty': '入れるファイルがありませんでした。',
  'upload.issue.noIndex': 'いちばん上に index.html が入っていません。AI に「index.html が入った zip を作り直して」と頼んでください。',
  'upload.zip.not_zip': 'zip として開けませんでした。ダウンロードが最後まで終わったか確かめて、もう一度落としてください。',
  'upload.zip.encrypted': 'パスワードのついた zip は開けません。パスワードなしで作り直してください。',
  'upload.zip.too_big': 'この zip は大きすぎて、ここでは開けません。zip を開いて、フォルダのまま落としてください。',
  'upload.zip.unsupported': 'この zip は、ここでは開けない作り方で作られています。ふつうの設定で作り直してください。',
  'upload.zip.broken': 'zip の中のファイルが壊れています。もう一度ダウンロードしてから落としてください。',
  'upload.noUnzip': 'このブラウザでは zip を開けません。zip を開いてフォルダのまま落とすか、新しいブラウザでお試しください。',
  'upload.error.off': 'テスト用のアプリで、まだ公開がオンになっていません。チャットで AI に「公開をオンにして」と頼んでから、もう一度ここで入れてください。',
  'upload.error.keyFound': 'キーのような文字列が見つかったので、入れませんでした（{files}）。AI にこのことを伝えて、アプリのファイルからキーを外してもらってください。',
  'upload.error.rateLimited': '短い間に何度も入れています。{seconds} 秒ほど待ってから、もう一度お試しください。',
  'upload.error.tooMany': '入れかけのものがたまっています。少し待ってから、もう一度お試しください。'
};
